import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './App.css'
import { ThemeProvider } from './contexts/ThemeContext'
import Shop from './Shop'
import ActiveProxies from './ActiveProxies'
import History from './History'
import Payments from './Payments'
import Tickets from './Tickets'
import ChangePassword from './ChangePassword'

const Login = lazy(() => import('./Login'))
const SignUp = lazy(() => import('./SignUp'))
const ForgotPassword = lazy(() => import('./ForgotPassword'))
const NoPage = lazy(() => import('./NoPage'))
const Admin = lazy(() => import('./admin/Admin'))
const PaymentSuccess = lazy(() => import('./PaymentSuccess'))
const PaymentError = lazy(() => import('./PaymentError'))
const LandingPage = lazy(() => import('./landing/LandingPage'))
const ApiDocsPage = lazy(() => import('./landing/ApiDocsPage'))
const UdpCheckerPage = lazy(() => import('./landing/UdpCheckerPage'))
const TermsPage = lazy(() => import('./landing/TermsPage'))
const PrivacyPage = lazy(() => import('./landing/PrivacyPage'))

const RouteFallback = () => (
  <div style={{
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--gradient-hero, #f5f5f5)'
  }}>
    <div style={{
      width: 32,
      height: 32,
      border: '2px solid var(--light-gray, #ddd)',
      borderTop: '2px solid var(--primary-orange, #D4AF37)',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
  </div>
)

function App(props) {
  return (
    <ThemeProvider>
      {/* Глобальное определение золотого градиента для SVG-иконок (вариант 11, вертикальный) */}
      <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="goldGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" style={{ stopColor: 'var(--gold-grad-0)' }} />
            <stop offset="35%" style={{ stopColor: 'var(--gold-grad-35)' }} />
            <stop offset="55%" style={{ stopColor: 'var(--gold-grad-55)' }} />
            <stop offset="75%" style={{ stopColor: 'var(--gold-grad-75)' }} />
            <stop offset="100%" style={{ stopColor: 'var(--gold-grad-100)' }} />
          </linearGradient>
          <linearGradient id="sidebarGoldGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#8A6D1F" />
            <stop offset="35%" stopColor="#C9A227" />
            <stop offset="55%" stopColor="#FFF3B0" />
            <stop offset="75%" stopColor="#C9A227" />
            <stop offset="100%" stopColor="#8A6D1F" />
          </linearGradient>
        </defs>
      </svg>
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="docs-api" element={<ApiDocsPage />} />
            <Route path="udp-checker" element={<UdpCheckerPage />} />
            <Route path="terms" element={<TermsPage />} />
            <Route path="terms-conditions" element={<TermsPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="privacy-policy" element={<PrivacyPage />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<SignUp />} />
            <Route path="passwdrecovery" element={<ForgotPassword />} />
            <Route path="admin" element={<Admin apiClient={props.apiClient} />} />
            <Route path="account" element={<ChangePassword user={props.userData} active={props.active} apiClient={props.apiClient}/>} />
            <Route path="proxies" element={<Shop user={props.userData} active={props.active} apiClient={props.apiClient} setReloadData={props.setReloadData} setReloadActive={props.setReloadActive} refreshUserData={props.refreshUserData}/>}/>
            <Route path="active" element={<ActiveProxies user={props.userData} active={props.active} apiClient={props.apiClient} setReloadActive={props.setReloadActive} refreshUserData={props.refreshUserData}/>}/>
            <Route path="history" element={<History user={props.userData} active={props.active} apiClient={props.apiClient} refreshUserData={props.refreshUserData}/>}/>
            <Route path="transactions" element={<Payments user={props.userData} active={props.active} apiClient={props.apiClient}/>}/>
            <Route path="tickets" element={<Tickets user={props.userData} active={props.active} apiClient={props.apiClient}/>}/>
            <Route path="paymentsuccess" element={<PaymentSuccess />} />
            <Route path="paymenterror" element={<PaymentError />} />
            <Route path="*" element={<NoPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
